export default __webpack_public_path__ + "static/media/pr.94171150.svg";